import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';

import { MeteringPointsEffectsModule } from '@appStore/metering-points/effects';
import { reducers } from '@appStore/metering-points/reducers';

export * from '@appStore/metering-points/reducers';
export * from '@appStore/metering-points/effects';
export * from '@appStore/metering-points/actions';

@NgModule({
  imports: [CommonModule, StoreModule.forFeature('meteringpoints', reducers), MeteringPointsEffectsModule]
})
export class MeteringPointsStoreModule {}
